import React from "react";
import {Box, Tabs, TabList, Tab, TabPanels, TabPanel, Heading} from "@chakra-ui/core";

import {Provider as SessionProvider} from "../../session/context";
import ProductsAdminScreen from "../../product/screens/Admin";
import TenantAdminScreen from "../../tenant/screens/Admin";

const AdminScreen: React.FC = () => (
  <SessionProvider>
    <Box height="100%" overflowY="auto" padding={{base: 3, sm: 6}}>
      <Heading as="h1" mb={{base: 3, sm: 6}} size="2xl">
        Panel de administración
      </Heading>
      <Tabs variant="soft-rounded" variantColor="primary">
        <TabList mb={{base: 3, sm: 6}}>
          <Tab>Productos</Tab>
          <Tab>Tienda</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <ProductsAdminScreen />
          </TabPanel>
          <TabPanel>
            <TenantAdminScreen />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  </SessionProvider>
);

export default AdminScreen;
